// VerdictBanner.js — the Tier-1 "Local Insight" strip: a compact banner mirroring
// the Weather insight banner, carrying the fn_li_page verdict sentence. State
// stays with the page (dismissed resets on client switch / retry), so this is
// presentational: verdict + onDismiss.
import React from 'react';
import PanelErrorBoundary from '../../shared/PanelErrorBoundary';

const VerdictBanner = ({ verdict, onDismiss }) => {
  if (!verdict) return null;
  return (
    <PanelErrorBoundary label="verdict">
      <div
        role="region"
        aria-label="Local Intelligence summary"
        className="relative rounded-xl border border-blue-200/60 dark:border-blue-400/20 bg-blue-50/50 dark:bg-blue-500/10 px-4 py-2.5"
      >
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss local insight"
          className="absolute top-2 right-2 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
        >
          <svg
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <div className="flex items-start gap-2.5 pr-7">
          <svg
            className="w-5 h-5 text-blue-500 dark:text-blue-400 flex-shrink-0 mt-0.5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M12 18h0M9 21h6M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2v1.1h5v-1.1c0-.8.4-1.5 1-2A6 6 0 0 0 12 3Z" />
          </svg>
          <div className="min-w-0">
            <span className="font-semibold text-gray-900 dark:text-gray-100 text-sm">Local Insight</span>
            <p className="text-sm text-gray-700 dark:text-gray-300 leading-snug min-w-0">{verdict}</p>
          </div>
        </div>
      </div>
    </PanelErrorBoundary>
  );
};

export default VerdictBanner;
